// src/components/Home/HowItWorks.jsx
import React from "react";

const steps = [
  {
    title: "1. Create your account",
    description:
      "Sign up in minutes and tell us about your AI agency or consulting services.",
  },
  {
    title: "2. Build your profile",
    description:
      "Add your services, use cases, tech stack, and client highlights so buyers can evaluate you fast.",
  },
  {
    title: "3. Get discovered",
    description:
      "Appear in relevant searches, receive qualified inquiries, and track performance over time.",
  },
  {
    title: "4. Upgrade for more visibility",
    description:
      "Move to Premium for priority ranking, CRM integration support, and advanced visibility insights.",
  },
];

const HowItWorks = () => {
  return (
    <section className="bg-gray-50 border-y mt-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="flex flex-col sm:flex-row justify-between gap-8 sm:items-center mb-10">
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-secondary">
              How To Get Started
            </h2>
            <p className="mt-3 text-gray-600 text-base sm:text-lg max-w-xl">
              New to AI Agency Directory. Follow these simple steps to join,
              publish your profile, and start receiving leads.
            </p>
          </div>
          <a href="/payments">
            <button className="bg-primary text-white rounded-full px-7 py-3 text-sm sm:text-base font-semibold hover:bg-blue-600 transition">
              View Plans and Sign Up
            </button>
          </a>
        </div>

        <div className="grid gap-6 sm:gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <div
              key={step.title}
              className="bg-white shadow-md rounded-2xl p-5 sm:p-6 border border-gray-100"
            >
              <h3 className="text-lg font-semibold text-secondary mb-2">
                {step.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
